import React, { useState } from 'react';
import { Avatar, IconButton, styled, Tooltip, Typography } from '@mui/material';
import {
  AiOutlinePlusCircle,
  AiOutlineCheckCircle,
  AiFillCheckCircle,
} from 'react-icons/ai';
import Link from 'next/link';
import { isEmpty, trim } from 'lodash-es';

const getCommunityLocation = (community) => {
  const location = [];
  if (community.city) location.push(community.city);
  else if (community.state) location.push(community.state);
  if (community.country) location.push(community.country);
  return location.join(', ');
};

function CommunityItem(props) {
  const { community, addCommunity, discardCommunity } = props;
  const [selected, setSelected] = useState(false);

  const handleSelected = (isSelected) => {
    setSelected(isSelected);
    if (isSelected) addCommunity(community);
    else discardCommunity(community);
  };

  return (
    <div className="flex justify-between items-center border border-gray-100 p-2 rounded group-hover:border-gray-200 cursor-pointer">
      <Link href={community.website_url} passHref>
        <div className="flex gap-4 items-center">
          <div className="shrink-0 grow-0">
            <Avatar src={community.logo_url} alt={community.name} size="sm" />
          </div>
          <div className="flex flex-col flex-1 justify-between items-start">
            <Typography
              variant="subtitle1"
              className="text-text-primary font-semibold line-clamp-1 group-hover:text-text-hyperlink overflow-ellipsis">
              {community.name}
            </Typography>
            <Typography
              variant="body1"
              color="textSecondary"
              className="line-clamp-1 overflow-ellipsis">
              {getCommunityLocation(community)}
            </Typography>
          </div>
        </div>
      </Link>
      <IconButton onClick={() => handleSelected(!selected)}>
        {selected ? (
          <AiFillCheckCircle size={24} className="w-9 h-9 text-primary" />
        ) : (
          <AiOutlinePlusCircle size={24} className="w-9 h-9 text-primary" />
        )}
      </IconButton>
    </div>
  );
}

export default CommunityItem;
